// extracted by mini-css-extract-plugin
module.exports = {"noResults":"NoResults_noResults__3nGvd","resetDataButtonWrapper":"NoResults_resetDataButtonWrapper__2H1DT"};